import { ReduceStore } from 'flux/utils';
import Immutable, { Record, Map, List } from 'immutable';
import LogStore from './LogStore';
import AppDispatcher from '../AppDispatcher';
import Constants from '../Constants';

const ResultFile = Record({
  name: '',
  url: '',
});

class JobResultsStore extends ReduceStore {
  getInitialState() {
    return new Map();
  }

  reduce(state, { actionType, ...action }) {
    this.getDispatcher().waitFor([
      LogStore.getDispatchToken()]
    );

    if (LogStore.hasChanged()) {
      switch (actionType) {
        case Constants.RECEIVE_JOB_LOGS:
          return this._updateResults(action.job);
        default:
          return state;
      }
    }
    return state;
  }

  _updateResults(jobId) {
    const oldResults = this.getState().get(jobId, new List());
    const newResults = LogStore.getLogs(jobId)
      .filter(v => typeof v.json.result !== 'undefined')
      .map(v => new ResultFile({
        name: 'file',
        url: v.json.result,
      }))
      .sortBy(v => v.name);
    const updated = !Immutable.is(newResults, oldResults);

    if (updated) {
      return this.getState().set(jobId, newResults);
    }
    return this.getState();
  }

  getJobResults(jobId) {
    return this.getState().get(jobId, new List());
  }


}

const instance = new JobResultsStore(AppDispatcher);
export default instance;
